import '../App.css';

export default function LoginPage({ credentials, error, onChange, onSubmit }) {
  const appIcon = encodeURI(`${process.env.PUBLIC_URL}/inokom_icon.png`);
  return (
    <div className="auth-page">
      <div className="auth-card glass">
        <div className="auth-brand">
          <img src={appIcon} alt="InokomView logo" className="auth-brand__logo" />
          <h1>InokomView</h1>
        </div>
        <p className="muted">*Enter the developer-provided credentials to continue.*</p>
        <form className="auth-form" onSubmit={onSubmit}>
          <label>
            Username
            <input
              name="username"
              type="text"
              value={credentials.username}
              onChange={onChange}
              placeholder="Enter username"
              autoComplete="username"
              required
            />
          </label>
          <label>
            Password
            <input
              name="password"
              type="password"
              value={credentials.password}
              onChange={onChange}
              placeholder="Enter password"
              autoComplete="current-password"
              required
            />
          </label>
          {error ? <p className="error">{error}</p> : null}
          <button type="submit" className="primary-button">
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}
